<template>
  <v-container fluid>
    <v-row v-if="loading">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-card class="px-3 pb-3 mb-4">
          <v-skeleton-loader type="list-item" class="mb-3"></v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" xl="3">
        <v-card class="px-3 pb-3 mb-4">
          <v-skeleton-loader type="list-item" class="mb-3"></v-skeleton-loader>
          <v-skeleton-loader type="image" class="mb-3"></v-skeleton-loader>
        </v-card>
        <v-card class="px-3 pb-3 mb-4">
          <v-skeleton-loader type="list-item" class="mb-3"></v-skeleton-loader>
          <v-skeleton-loader type="image" class="mb-3"></v-skeleton-loader>
        </v-card>
        <v-card class="px-3 pb-3">
          <v-skeleton-loader type="list-item" class="mb-3"></v-skeleton-loader>
          <v-skeleton-loader type="image" class="mb-3"></v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="6" xl="7">
        <v-card class="px-2 pb-4 mb-4">
          <v-skeleton-loader type="list-item" class="mb-3"></v-skeleton-loader>
          <v-skeleton-loader type="image, image" class="mb-3"></v-skeleton-loader>
        </v-card>
        <v-card class="px-3 pb-3">
          <v-skeleton-loader type="list-item" class="mb-3"></v-skeleton-loader>
          <v-skeleton-loader type="image" class="mb-3"></v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" xl="2">
        <v-card class="px-3 pb-3 mb-4">
          <v-skeleton-loader type="list-item" class="mb-3"></v-skeleton-loader>
          <v-skeleton-loader type="image" class="mb-3"></v-skeleton-loader>
        </v-card>
        <v-card class="px-3 pb-3 mb-4">
          <v-skeleton-loader type="list-item" class="mb-3"></v-skeleton-loader>
          <v-skeleton-loader type="image" class="mb-3"></v-skeleton-loader>
        </v-card>
        <v-card class="px-3 pb-3">
          <v-skeleton-loader type="list-item" class="mb-3"></v-skeleton-loader>
          <v-skeleton-loader type="image" class="mb-3"></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
        <v-row no-gutters>
          <div class="my-1">
            <VueCtkDateTimePicker
              v-on:callback="changeDates"
              v-model="data_entrada"
              class="date-picker"
              locale="pt-BR"
              :no-header="true"
              :no-value-to-custom-elem="true"
              :overlay="true"
              :range="true"
              :formatted="'L'"
              :format="'YYYY-MM-DD'"
              color="#EC6521"
              :dark="$vuetify.theme.dark"
              button-color="#EC6521"
              :custom-shortcuts="labels"
              :no-button="true"
              :noClearButton="true"
              :auto-close="true"
              :loading="loadingSearch"
              :disabled="loadingSearch"
              :submit="retornoData()"
            >
              <v-btn class="px-2 py-1 search_data" elevation="0" v-ripple="{ class: `success--text` }">
                <b class="text text-primary">
                  Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                </b>
              </v-btn>
            </VueCtkDateTimePicker>
          </div>
          <div class="ml-3 mw_autoc my-1">
            <v-autocomplete
              :menu-props="{ offsetY: true}"
              v-model="usina"
              :items="usinas"
              clearable
              clear-icon="close"
              label="Usina"
              hide-details=""
              append-icon="expand_more"
              :loading="loadingSearch || loadingUsinas"
              :disabled="loadingSearch || loadingUsinas"
              outlined
            >
            </v-autocomplete>
          </div>
          <div class="ml-3 mw_autoc my-1">
            <v-autocomplete
              :menu-props="{ offsetY: true}"
              v-model="status"
              :items="statusItens"
              clearable
              clear-icon="close"
              label="Status"
              hide-details=""
              append-icon="expand_more"
              :loading="loadingSearch || loadingStatus"
              :disabled="loadingSearch || loadingStatus"
              outlined
            >
            </v-autocomplete>
          </div>
          <div class="ml-3 mw_autoc my-1">
            <v-autocomplete
              :menu-props="{ offsetY: true}"
              v-model="cidade"
              :items="cidades"
              clearable
              clear-icon="close"
              label="Cidade"
              hide-details=""
              append-icon="expand_more"
              :loading="loadingSearch || loadingUsinas"
              :disabled="loadingSearch || loadingUsinas"
              outlined
            >
            </v-autocomplete>
          </div>
          <div class="ml-3 mw_autoc my-1">
            <v-autocomplete
              :menu-props="{ offsetY: true}"
              v-model="cliente"
              :items="clientes"
              clearable
              clear-icon="close"
              label="Cliente"
              hide-details=""
              append-icon="expand_more"
              :loading="loadingSearch || loadingClientes"
              :disabled="loadingSearch || loadingClientes"
              outlined
            >
            </v-autocomplete>
          </div>
          <div class="ml-3 my-1">
            <v-range-slider
              v-model="range"
              dense
              :loading="loadingSearch"
              :disabled="loadingSearch"
              class="range_mw"
              :hint="range ? range[0] + '% ' + range[1] + '%' : ''"
              max="150"
              min="0"
              label="% Desempenho"
              persistent-hint
            >
            </v-range-slider>
          </div>
          <div class="ml-1 my-1">
            <v-row no-gutters>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="ui-btn-inherit" v-bind="attrs" v-on="on" :loading="loadingSearch" :disabled="loadingSearch" @click="applyFilter()">
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
                <span>Filtrar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="ui-btn-inherit ml-3" v-bind="attrs" v-on="on" :loading="loadingSearch" :disabled="loadingSearch" @click="clearFilter()">
                    <v-icon>close</v-icon>
                  </v-btn>
                </template>
                <span>Limpar Filtro</span>
              </v-tooltip>
            </v-row>
          </div>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" xl="3">
        <v-card class="px-3 pb-6">
          <div class="text-center text-h3 text-primary mb-3 pt-2">
            Status das usinas
          </div>
          <!-- <bar-chart :options="barChartOptions" :height="220" :data="barChartData"></bar-chart> -->
          <v-row class="pb-4 pt-3">
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0" v-for="(item, index) in dados.usinas.status" :key="index">
              <div class="py-2 px-1 lh-normal text-center text-white" :class="item.label === 'Online' ? 'bg-green' : item.label === 'Offline' ? 'bg-red' : item.label === 'Alerta' ? 'bg-primary' : item.label === 'Não definido' ? 'bg-yellow' : item.label === 'Sem conexão' ? 'bg-blue' : item.label === 'Sem retorno' ? 'bg-gray' : 'bg-gray'">
                {{item.label}} <b>{{item.total}}</b>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-3">
          <div class="text-center text-h3 text-primary mb-3 pt-2">
            Chamados
          </div>
          <doughnut-chart v-if="doughnutChartData.datasets && doughnutChartData.datasets.length" class="pb-4 pt-3" :options="doughnutChartOptions" :height="220" :data="doughnutChartData"></doughnut-chart>
          <div v-else class="chamado-sem-dados text-center">
            <v-icon :color="this.$root.$vuetify.theme.isDark ? '#363636' : '#36363638'">running_with_errors</v-icon>
            <p class="text--thin text-center pt-3">Não há dados de chamados para o período informado</p>
          </div>
        </v-card>
        <v-card class="mt-6 pb-3">
          <div class="text-center text-h3 text-primary mb-3 pt-2">
            Acesso dos clientes
          </div>
          <doughnut-chart v-if="doughnutChartDataAcessos.datasets && doughnutChartDataAcessos.datasets.length" class="pb-4 pt-3" :options="doughnutChartOptions" :height="220" :data="doughnutChartDataAcessos"></doughnut-chart>
          <div v-else class="chamado-sem-dados text-center">
            <v-icon :color="this.$root.$vuetify.theme.isDark ? '#363636' : '#36363638'">running_with_errors</v-icon>
            <p class="text--thin text-center pt-3">Não há dados de chamados para o período informado</p>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="6" xl="7">
        <v-card class="px-2 pb-4" v-if="!loading">
          <mapa-calor :key="key" :localizations="dados && dados.usinas ? dados.usinas.lista : null"></mapa-calor>
        </v-card>
        <v-row>
          <v-col cols="12" sm="12" md="6" v-if="dados && dados.geracao">
            <v-card class="mt-6" style="cursor: pointer" @click="openDialogBarChart('Geração:', barChartDataProduction, barChartOptionsGeracao)">
              <div class="text-center text-h3 text-primary mb-3 pt-2">
                Geração:
              </div>
              <bar-chart :options="barChartOptionsGeracao" :height="181" :data="barChartDataProduction"></bar-chart>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-card class="mt-6" style="cursor: pointer" @click="openDialogBarChart('Desempenho:', barChartDataPerformance, barChartOptionsDesempenho)">
              <div class="text-center text-h3 text-primary mb-3 pt-2">
                Desempenho:
              </div>
              <bar-chart :options="barChartOptionsDesempenho" :height="181" :data="barChartDataPerformance"></bar-chart>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" xl="2" class="scroll_personalizado" v-if="dados && dados.usinas">
        <v-card class="text-center py-3">
          <div class="text-h1 text-primary">
            <b>
              {{dados.usinas.qtdUsinas}}
            </b>
            <span class="qtd-total-label">
              / {{ dados.usinas.qtdTotalUsinas }}
            </span>
          </div>
          <div class="text text-primary">
            Usina{{dados.usinas.qtdUsinas.length === 1 ? '' : 's'}}
          </div>
        </v-card>
        <v-card class="text-center py-3 mt-6">
          <div class="text-h1 text-primary">
            <b>
              <!-- {{$root.Formatter.floatToMoney(dados.usinas.potencia_instalada)}} -->
              {{dados.usinas.potencia_instalada}}
            </b>
            <span class="qtd-total-label">
              / {{ dados.usinas.potencia_instalada_total }}
            </span>
          </div>
          <div class="text text-primary">
            Potência instalada
          </div>
        </v-card>
        <v-card class="text-center py-3 mt-6 px-3" v-if="dados && dados.usinas && dados.usinas.desempenho_geral">
          <div class="text-h3 text-primary mb-3 pt-2">
            Desempenho
            <v-tooltip top v-if="filtroSelecionado">
              <template v-slot:activator="{ on, attrs }">
                <v-icon @click="filtroDesempenho()" v-bind="attrs" v-on="on" color="primary">filter_alt_off</v-icon>
              </template>
              <span>Limpar filtro</span>
            </v-tooltip>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
              <div :class="filtroSelecionado === 1 ? $vuetify.theme.dark ? 'border-selected-white' : 'border-selected-black' : ''" class="bg-green border_item py-2 px-1 lh-normal text-white cursor-pointer" v-ripple="{ class: `success--text` }" @click="filtroDesempenho(1)">
                Bom <b>{{dados.usinas.desempenho_geral.bom}}</b>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
              <div :class="filtroSelecionado === 2 ? $vuetify.theme.dark ? 'border-selected-white' : 'border-selected-black' : ''" class="bg-yellow border_item py-2 px-1 lh-normal text-white cursor-pointer" v-ripple="{ class: `success--text` }" @click="filtroDesempenho(2)">
                Médio <b>{{dados.usinas.desempenho_geral.medio}}</b>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <div :class="filtroSelecionado === 3 ? $vuetify.theme.dark ? 'border-selected-white' : 'border-selected-black' : ''" class="bg-red border_item py-2 px-1 lh-normal text-white cursor-pointer" v-ripple="{ class: `success--text` }" @click="filtroDesempenho(3)">
                Baixo <b>{{dados.usinas.desempenho_geral.ruim}}</b>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <div :class="filtroSelecionado === 4 ? $vuetify.theme.dark ? 'border-selected-white' : 'border-selected-black' : ''" class="bg-blue border_item py-2 px-1 lh-normal text-white cursor-pointer" v-ripple="{ class: `success--text` }" @click="filtroDesempenho(4)">
                Sem dados <b>{{dados.usinas.desempenho_geral.sem_dados}}</b>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 text-center px-3 pb-2 scroll_area">
          <div class="text-h3 text-primary mb-3 pt-2">
            Usinas
          </div>
          <div v-for="(item, index) in dados.usinas.lista" :key="index" @click="goToInterna(item)" class="cursor-pointer">
            <div class="totalizador_cliente mb-3 py-2" :style="item.status.uss_nome === 'Online' ? 'border-color: #118F2D' : item.status.uss_nome === 'Offline' ? 'border-color: #FF0B0B' : item.status.uss_nome === 'Alerta' ? 'border-color: #EC6521' : item.status.uss_nome === 'Não definido' ? 'border-color: #F8B518' : item.status.uss_nome === 'Sem conexão' ? 'border-color: #4393B6' : item.status.uss_nome === 'Sem retorno' ? 'border-color: #8A8A8A' : 'border-color: #8A8A8A'">
              <div class="text mb-1" :class="$vuetify.theme.dark ? 'text-white' : 'text-black'">
                <b>
                  {{item.cliente ? item.cliente.cli_nome : ''}} - {{item.usi_nome}}
                </b>
              </div>
              <div class="text" :class="item.status.uss_nome  === 'Online' ? 'text-green' : item.status.uss_nome  === 'Offline' ? 'text-red' : item.status.uss_nome  === 'Alerta' ? 'text-primary' : item.status.uss_nome  === 'Não definido' ? 'text-yellow' : item.status.uss_nome  === 'Sem conexão' ? 'text-blue' : item.status.uss_nome  === 'Sem retorno' ? 'text-gray' : 'text-gray'">
                {{item.status.uss_nome}}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogBarChart" persistent max-width="1200">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{ dialogBarChartTitle }}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogBarChart()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div v-if="dialogBarChartData && dialogBarChartOptions">
          <bar-chart :options="dialogBarChartOptions" :data="dialogBarChartData" :styles="{height: '400px', position: 'relative'}"></bar-chart>
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="end"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            @click="closeDialogBarChart()"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import BarChart from '@components/graficos/BarChart.vue'
import DoughnutChart from '@components/graficos/DoughnutChart.vue'
import MapaCalor from '@components/graficos/MapaCalor.vue'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
  components: {
    BarChart,
    DoughnutChart,
    MapaCalor,
    VueCtkDateTimePicker
  },
  data () {
    return {
      dados: [],
      loading: false,
      loadingSearch: false,
      dialogBarChart: false,
      dialogBarChartTitle: '',
      dialogBarChartOptions: {},
      dialogBarChartData: {},
      barChartDataProduction: {},
      barChartDataPerformance: {},
      barChartData: {},
      key: 0,
      barChartOptionsGeracao: {
        legend: { display: false },
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                if (value >= 1000) {
                  return (value / 1000) + ' MWh'
                } else {
                  return value + ' kWh'
                }
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              if (tooltipItem.value >= 1000) {
                let r = tooltipItem.value / 1000
                r = `` + r + ``
                return Number(r).toFixed(4).replace('.', ',') + ' MWh'
              } else {
                return Number(tooltipItem.value).toFixed(4).replace('.', ',') + ' kWh'
              }
            }
          }
        }
      },
      barChartOptionsDesempenho: {
        legend: { display: false },
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return value + '%'
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              // console.log(tooltipItem.yLabel, tooltipItem)
              return tooltipItem.value.replace('.', ',') + '%'
            }
          }
        }
      },
      doughnutChartOptions: {
        responsive: true,
        cutoutPercentage: 70,
        maintainAspectRatio: false,
        legend: {
          position: 'right'
        }
      },
      doughnutChartDataAcessos: {},
      doughnutChartData: {},
      de: moment(new Date()).format('YYYY-MM-DD'),
      // de: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        start: moment(new Date()).format('YYYY-MM-DD'),
        // start: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      usinas: [],
      usina: '',
      statusItens: '',
      status: '',
      range: [0, 100],
      clientes: [],
      cliente: '',
      cidades: [],
      cidade: '',
      loadingClientes: false,
      loadingStatus: false,
      loadingUsinas: false,
      usinasCopia: [],
      filtroSelecionado: ''
    }
  },
  methods: {
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          // this.applyFilter()
        }
      }
    },
    clearFilter () {
      this.loading = true
      // this.de = moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD')
      this.de = moment(new Date()).format('YYYY-MM-DD')
      this.ate = moment(new Date()).format('YYYY-MM-DD')
      // this.data_entrada.start = moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD')
      this.data_entrada.start = moment(new Date()).format('YYYY-MM-DD')
      this.data_entrada.end = moment(new Date()).format('YYYY-MM-DD')
      this.usina = ''
      this.cliente = ''
      this.status = ''
      this.range = [0, 100]
      this.cidade = ''
      this.$router.replace({name: 'PainelInicial', query: null}).catch(() => {})
      this.loadContent()
    },
    applyFilter () {
      this.loading = true
      let query = Object.assign({},
        this.de ? { de: this.de } : '',
        this.ate ? { ate: this.ate } : '',
        this.usina ? { usina: this.usina } : '',
        this.cliente ? { cliente: this.cliente } : '',
        this.status ? { status: this.status } : '',
        this.range ? { range: this.range } : '',
        this.cidade ? { cidade: this.cidade } : ''
      )
      this.$router.replace({name: 'PainelInicial', query: query}).catch(() => {})
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      this.loadFunctions(this.de, this.ate, this.usina, this.cliente, this.status, this.range, this.cidade)
    },
    loadFunctions (inicio, fim, usi, cli, stat, ran, city) {
      let endpoint = inicio ? '?de=' + inicio : '?de='
      endpoint += fim ? '&ate=' + fim : '&ate='
      endpoint += usi ? '&usina=' + usi : '&usina='
      endpoint += usi ? '&usina=' + usi : '&usina='
      endpoint += cli ? '&cliente=' + cli : '&cliente='
      endpoint += stat ? '&status=' + stat : '&status='
      endpoint += ran ? '&range=' + ran[0] + '-' + ran[1] : '&range='
      endpoint += city ? '&cidade=' + city : '&cidade='
      this.getDados(endpoint)
    },
    loadContent () {
      this.getUsinas()
      this.getStatus()
      this.getClientes()
      this.getCidades()
      let filters = this.$route.query
      if (filters.de) this.de = filters.de
      if (filters.ate) this.ate = filters.ate
      if (filters.usina) this.usina = filters.usina
      if (filters.cliente) this.cliente = filters.cliente
      if (filters.status) this.status = filters.status
      if (filters.range) this.range = filters.range
      if (filters.cidade) this.cidade = filters.cidade
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      this.loadFunctions(this.de, this.ate, this.usina, this.cliente, this.status, this.range, this.cidade)
    },
    filtroDesempenho (value) {
      if (value) {
        let usinasFiltro = []
        this.usinasCopia.filter((res) => {
          if (value === 1) {
            if (res.desempenho_status === 'bom') {
              usinasFiltro.push(res)
            }
          }
          if (value === 2) {
            if (res.desempenho_status === 'medio') {
              usinasFiltro.push(res)
            }
          }
          if (value === 3) {
            if (res.desempenho_status === 'ruim') {
              usinasFiltro.push(res)
            }
          }
          if (value === 4) {
            if (res.desempenho_status === 'sem_dados') {
              usinasFiltro.push(res)
            }
          }
        })
        console.log(usinasFiltro.length)
        // console.table(usinasFiltro)
        this.key++
        this.filtroSelecionado = value
        this.dados.usinas.lista = JSON.parse(JSON.stringify(usinasFiltro))
      } else {
        this.key++
        this.filtroSelecionado = ''
        this.dados.usinas.lista = JSON.parse(JSON.stringify(this.usinasCopia))
      }
    },
    async getDados (endpoint) {
      this.loading = true
      await Api.get('dashboard' + endpoint)
        .then(res => {
          if (res.data.chamados) {
            if (res.data.chamados.data[0] || res.data.chamados.data[1] || res.data.chamados.data[2]) {
              this.doughnutChartData = {
                labels: res.data.chamados.labels,
                datasets: [
                  {
                    label: 'Chamados',
                    backgroundColor: ['#4393B6', '#118F2D', '#EC6521'],
                    data: res.data.chamados.data
                  }
                ]
              }
            } else {
              this.doughnutChartData = {
                datasets: []
              }
            }
          }
          if (res.data.usinas) {
            if (res.data.usinas.status) {
              this.barChartData = {
                labels: res.data.usinas.status.labels,
                datasets: [
                  {
                    label: 'Status usinas',
                    backgroundColor: ['#FF0B0B', '#118F2D', '#EC6521', '#F8B518', '#4393B6', '#8A8A8A'],
                    data: res.data.usinas.status.data
                  }
                ]
              }
            }
          }

          if (res.data.geracao) {
            this.barChartDataProduction = {
              labels: res.data.geracao.labels,
              datasets: [
                {
                  label: res.data.geracao.label,
                  backgroundColor: '#EC6521',
                  data: res.data.geracao.data
                }
              ]
            }
          }

          if (res.data.desempenho) {
            this.barChartDataPerformance = {
              labels: res.data.desempenho.labels,
              datasets: [
                {
                  label: res.data.desempenho.label,
                  backgroundColor: '#4393B6',
                  data: res.data.desempenho.data
                }
              ]
            }
          }

          if (res.data.acessos) {
            this.doughnutChartDataAcessos = {
              labels: res.data.acessos.labels,
              datasets: [
                {
                  label: res.data.acessos.datasets.label,
                  backgroundColor: res.data.acessos.datasets.backgroundColor,
                  data: res.data.acessos.datasets.data
                }
              ]
            }
          }

          this.dados = res.data
          if (res.data.usinas && res.data.usinas.lista) {
            this.usinasCopia = JSON.parse(JSON.stringify(res.data.usinas.lista))
          }
          console.log(res.data)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getUsinas () {
      this.loadingUsinas = true
      await Api.get('usinas')
        .then(res => {
          var arrayUsi = []
          res.data.map(usi => {
            arrayUsi.push({
              'text': usi.usi_nome,
              'value': usi.uuid_usi_id
            })
          })
          this.usinas = arrayUsi
          this.loadingUsinas = false
        })
        .catch(err => {
          this.loadingUsinas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as usinas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getClientes () {
      this.loadingClientes = true
      await Api.get('clientes')
        .then(res => {
          var arrayCli = []
          res.data.map(cli => {
            arrayCli.push({
              'text': cli.cli_nome,
              'value': cli.uuid_cli_id
            })
          })
          this.clientes = arrayCli
          this.loadingClientes = false
        })
        .catch(err => {
          this.loadingClientes = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os clientes!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getCidades () {
      this.loadingCidades = true
      await Api.get('dashboard/cidades')
        .then(res => {
          var arrayCity = []
          res.data.map(usi => {
            arrayCity.push({
              'text': `${usi.usi_cidade} - ${usi.usi_uf}`,
              'value': usi.usi_cidade
            })
          })
          this.cidades = arrayCity
          this.loadingCidades = false
        })
        .catch(err => {
          this.loadingCidades = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as cidades!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getStatus () {
      this.loadingStatus = true
      await Api.get('usinas-status')
        .then(res => {
          var arrayStat = []
          res.data.map(sta => {
            arrayStat.push({
              'text': sta.uss_nome,
              'value': sta.uuid_uss_id
            })
          })
          this.statusItens = arrayStat
          this.loadingStatus = false
        })
        .catch(err => {
          this.loadingStatus = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os status!',
            color: 'error'
          })
          console.log(err)
        })
    },
    goToInterna (item) {
      this.$router.push({ name: 'VisaoGeralInterna', params: { uuid: item.uuid_usi_id } }).catch(() => {})
    },
    openDialogBarChart (title, data, option) {
      this.dialogBarChart = true

      this.dialogBarChartTitle = title
      this.dialogBarChartOptions = { ...option, maintainAspectRatio: false }
      this.dialogBarChartData = data
    },
    closeDialogBarChart () {
      this.dialogBarChart = false

      this.dialogBarChartTitle = ''
      this.dialogBarChartOptions = null
      this.dialogBarChartData = null
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.totalizador_cliente {
  border: solid;
  border-width: 2px;
  border-left-width: 6px;
  border-radius: 0px!important;
}
.scroll_area {
  max-height: 480px;
  overflow: auto;
}
.search_data {
  padding-bottom: 10px!important;
  padding-top: 11px!important;
}
.range_mw {
  min-width: 350px;
  >>> .v-messages__wrapper {
    margin-left: 35px;
    margin-top: -10px;
  }
}
.mw_autoc {
  max-width: 200px;
}
.border_item {
  border: 2px transparent solid;
  transition: all 0.3s;
}
.border-selected-black {
  border-color: black;
  transition: all 0.3s;
}
.border-selected-white {
  border-color: white;
  transition: all 0.3s;
}
.chamado-sem-dados {
  min-height: 15.5em;
  padding-top: 0em;
  .v-icon {
    font-size: 12em;
  }
}

.qtd-total-label {
  font-size: 14px;
  font-weight: bold !important;
  color: #6e6e6e;
}
</style>



// WEBPACK FOOTER //
// src/pages/painelInicial/TheHome.vue